import { useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { mountTool } from '../main.js';

import '../ui/styles/variables.css';
import '../ui/styles/base.css';
import '../ui/styles/tool.css';

export default function ToolPage() {
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const container = ref.current;
    const handle = mountTool(container);

    // Wire upgrade CTAs to the pricing page
    container.querySelectorAll('a[href="#upgrade"]').forEach((link) => {
      link.href = '/pricing';
      link.addEventListener('click', (e) => {
        e.preventDefault();
        navigate('/pricing');
      });
    });

    return () => handle.destroy();
  }, [navigate]);

  return <div ref={ref} className="clip-looper-tool" />;
}
